// src/pages/Dashboard.js
import React from 'react';
import { Activity, Radio, Car, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
// import './Dashboard.css';
import "./index.css"

const Dashboard = () => {
  // --- Mock Data ---
  const stats = [
    { label: 'Total RSU', value: 24, icon: Radio, color: '#8b5cf6', sub: 'All Systems Operational' },
    { label: 'Active OBU', value: 156, icon: Car, color: '#10b981', sub: 'Vehicles on Chalong Rat' },
    { label: 'Events Today', value: 12, icon: AlertTriangle, color: '#f59e0b', sub: 'Last update: 1 min ago' },
    { label: 'System Health', value: '98%', icon: Activity, color: '#3b82f6', sub: 'Server Load Normal' },
  ];

  const recentEvents = [
    { id: 101, time: '10:42 AM', type: 'Accident', location: 'KM 12+500', source: 'OBU-TH-881', status: 'Active' },
    { id: 102, time: '10:38 AM', type: 'Road Work', location: 'KM 08+200', source: 'RSU-04', status: 'Resolved' },
    { id: 103, time: '10:15 AM', type: 'Emergency Brake', location: 'KM 14+100', source: 'OBU-TH-999', status: 'Resolved' },
    { id: 104, time: '09:50 AM', type: 'Rain Warning', location: 'Zone A', source: 'Central', status: 'Active' },
    { id: 105, time: '09:30 AM', type: 'Overspeed', location: 'KM 05+000', source: 'RSU-02', status: 'Logged' },
  ];

  const rsuStatus = [
    { name: 'RSU-01', status: 'online' }, { name: 'RSU-02', status: 'online' },
    { name: 'RSU-03', status: 'warning' }, { name: 'RSU-04', status: 'online' },
    { name: 'RSU-05', status: 'offline' }, { name: 'RSU-06', status: 'online' },
  ];

 const linkStyle = {
      textDecoration: "none",   // ไม่มีเส้นใต้
      padding: "10px",          // ระยะห่างจากขอบทั้ง 4
      borderRadius: "10px",     // มุมมน
      backgroundColor: "#f0f0f0", // เพิ่มสีพื้นหลังให้เห็นชัด
      color: "#6c6868" ,            // สีตัวอักษร
      backgroundColor:"#d1f479",
      boxShadow: "1px 1px 3px #6e6767", // เงา (x-offset y-offset blur color)
       fontWeight: "600" ,
    };



  return (
    <div className="dashboard-container">
      <h2 className="page-title">System Overview</h2>

      {/* 1. Summary Cards */}
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
              <stat.icon size={24} />
            </div>
            <div className="stat-info">
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
              <span className="stat-sub">{stat.sub}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-content">
        {/* 2. RSU Health Status */}
        <div className="content-card rsu-health">
          <div className="card-header">
            <h3>RSU Connectivity Status</h3>
            <button className="btn-link"><a style={linkStyle} href='http://localhost:3000/rsu'>View RSU</a></button>
          </div>
          <div className="rsu-grid">
            {rsuStatus.map((rsu, idx) => (
              <div key={idx} className={`rsu-item ${rsu.status}`}>
                <div className="status-dot"></div>
                <span>{rsu.name}</span>
              </div>
            ))}
          </div>
          <div className="health-summary">
            <div className="legend"><span className="dot online"></span> Online (4)</div>
            <div className="legend"><span className="dot warning"></span> Warning (1)</div>
            <div className="legend"><span className="dot offline"></span> Offline (1)</div>
          </div>
        </div>

        {/* 3. Recent Event Log */}
        <div className="content-card event-log">
          <div className="card-header">
            <h3>Recent V2X Events</h3>
            <button className="btn-link"><a style={linkStyle} href='http://localhost:3000/event'>View All</a></button>
          </div>
          <table className="table-minimal">
            <thead>
              <tr>
                <th>Time</th>
                <th>Type</th>
                <th>Location</th>
                <th>Source</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {recentEvents.map((ev) => (
                <tr key={ev.id}>
                  <td>{ev.time}</td>
                  <td>
                    <span className={`badge-type ${ev.type.split(' ')[0].toLowerCase()}`}>{ev.type}</span>
                  </td>
                  <td>{ev.location}</td>
                  <td>{ev.source}</td>
                  <td>
                    <span className={`status-text ${ev.status.toLowerCase()}`}>
                      {ev.status === 'Active' ? <AlertTriangle size={14}/> : <CheckCircle size={14}/>} {ev.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;